var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVeterinaryMedicine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "137.31 121.71 116.86 121.71 116.86 101.26 103.09 101.26 103.09 121.71 82.64 121.71 82.64 135.48 103.09 135.48 103.09 155.93 116.86 155.93 116.86 135.48 137.31 135.48 137.31 121.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.86,148.75c0,56.48-28.66,21.43-64,21.43s-64,33.75-64-21.43c0-34,28.65-61.65,64-61.65S173.86,114.7,173.86,148.75Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 85.08,
    cy: 54.53,
    rx: 15,
    ry: 20.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 128.58,
    cy: 52.86,
    rx: 15,
    ry: 20.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 164.12,
    cy: 75.28,
    rx: 11.3,
    ry: 15.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 49.69,
    cy: 82.95,
    rx: 11.3,
    ry: 15.26
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeterinaryMedicine);
export default __webpack_public_path__ + "static/media/VETERINARY_MEDICINE.55ce3c3ce77a953c80d5426795616be1.svg";
export { ForwardRef as ReactComponent };